import { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { saveAs } from 'file-saver'
import { deepCopy } from '../../../../util/Utils'
import useNotifications from '../../../../hooks/useNotifications'
import { createCards, getCards } from '../../../../services/FamilyCardsService'

const actions = {
  SET_CHECKBOX_BAPTISM: 'SET_CHECKBOX_BAPTISM',
  SET_CHECKBOX_CONFIRMATION: 'SET_CHECKBOX_CONFIRMATION',
  SET_CHECKBOX_INITIATORY: 'SET_CHECKBOX_INITIATORY',
  SET_CHECKBOX_ENDOWMENT: 'SET_CHECKBOX_ENDOWMENT',
  SET_CHECKBOX_SEALING_TO_PARENTS: 'SET_CHECKBOX_SEALING_TO_PARENTS',
  SET_CHECKBOX_SEALING_TO_SPOUSE: 'SET_CHECKBOX_SEALING_TO_SPOUSE',
  SET_CHECKBOX_EXCLUDE_CONTACT_INFO: 'SET_CHECKBOX_EXCLUDE_CONTACT_INFO',
  SET_AUTOSUGGEST_PARENTS: 'SET_AUTOSUGGEST_PARENTS',
  SET_AUTOSUGGEST_SPOUSE: 'SET_AUTOSUGGEST_SPOUSE',
  SET_LANG: 'SET_LANG',
  HANDLE_CLOSE: 'HANDLE_CLOSE',
}

function printCardsReducer(oldState, action) {
  const newState = deepCopy(oldState)
  const type = action.type
  const payload = action.payload
  if (type === actions.SET_CHECKBOX_BAPTISM) {
    newState.checkboxBaptism = payload.checkboxBaptism
  } else if (type === actions.SET_CHECKBOX_CONFIRMATION) {
    newState.checkboxConfirmation = payload.checkboxConfirmation
  } else if (type === actions.SET_CHECKBOX_INITIATORY) {
    newState.checkboxInitiatory = payload.checkboxInitiatory
  } else if (type === actions.SET_CHECKBOX_ENDOWMENT) {
    newState.checkboxEndowment = payload.checkboxEndowment
  } else if (type === actions.SET_CHECKBOX_SEALING_TO_PARENTS) {
    newState.checkboxSealingToParents = payload.checkboxSealingToParents
  } else if (type === actions.SET_CHECKBOX_SEALING_TO_SPOUSE) {
    newState.checkboxSealingToSpouse = payload.checkboxSealingToSpouse
  } else if (type === actions.SET_CHECKBOX_EXCLUDE_CONTACT_INFO) {
    newState.checkboxExcludeContactInfo = payload.checkboxExcludeContactInfo
  } else if (type === actions.SET_AUTOSUGGEST_PARENTS) {
    newState.selectedParents = payload.selectedParents
  } else if (type === actions.SET_AUTOSUGGEST_SPOUSE) {
    newState.selectedSpouse = payload.selectedSpouse
  } else if (type === actions.SET_LANG) {
    newState.selectedLang = payload.selectedLang
  } else if (type === actions.HANDLE_CLOSE) {
    newState.checkboxBaptism = false
    newState.checkboxConfirmation = false
    newState.checkboxInitiatory = false
    newState.checkboxEndowment = false
    newState.checkboxSealingToParents = false
    newState.checkboxSealingToSpouse = false
    newState.checkboxExcludeContactInfo = false
    newState.selectedParents = undefined
    newState.selectedSpouse = undefined
  }
  return newState
}

export default function usePrintCardsController(currentPerson, effectiveOrdinances, opener, ordinanceData) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const initialState = {
    checkboxBaptism: false,
    checkboxConfirmation: false,
    checkboxInitiatory: false,
    checkboxEndowment: false,
    checkboxSealingToParents: false,
    checkboxSealingToSpouse: false,
    checkboxExcludeContactInfo: false,
    selectedLang: 'en',
    selectedParents: { key: 'selectedParents', primaryText: '' },
    selectedSpouse: { key: 'selectedSpouse', primaryText: '' },
  }

  const [printCardsState, printCardsDispatch] = useReducer(printCardsReducer, initialState)

  const printCardsActions = {
    setCheckboxBaptism: (checkboxBaptism) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_BAPTISM,
        payload: {
          checkboxBaptism,
        },
      })
    },
    setCheckboxConfirmation: (checkboxConfirmation) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_CONFIRMATION,
        payload: {
          checkboxConfirmation,
        },
      })
    },
    setCheckboxInitiatory: (checkboxInitiatory) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_INITIATORY,
        payload: {
          checkboxInitiatory,
        },
      })
    },
    setCheckboxEndowment: (checkboxEndowment) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_ENDOWMENT,
        payload: {
          checkboxEndowment,
        },
      })
    },
    setCheckboxSealingToParents: (checkboxSealingToParents) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_SEALING_TO_PARENTS,
        payload: {
          checkboxSealingToParents,
        },
      })
    },
    setCheckboxSealingToSpouse: (checkboxSealingToSpouse) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_SEALING_TO_SPOUSE,
        payload: {
          checkboxSealingToSpouse,
        },
      })
    },
    setCheckboxExcludeContactInfo: (checkboxExcludeContactInfo) => {
      printCardsDispatch({
        type: actions.SET_CHECKBOX_EXCLUDE_CONTACT_INFO,
        payload: {
          checkboxExcludeContactInfo,
        },
      })
    },
    setSelectedParents: (selectedParents) => {
      printCardsDispatch({
        type: actions.SET_AUTOSUGGEST_PARENTS,
        payload: {
          selectedParents,
        },
      })
    },
    setSelectedSpouse: (selectedSpouse) => {
      printCardsDispatch({
        type: actions.SET_AUTOSUGGEST_SPOUSE,
        payload: {
          selectedSpouse,
        },
      })
    },
    setSelectedLang: (selectedLang) => {
      printCardsDispatch({
        type: actions.SET_LANG,
        payload: {
          selectedLang,
        },
      })
    },
    handleClose: () => {
      opener.close()
      printCardsDispatch({
        type: actions.HANDLE_CLOSE,
      })
    },
    existsOrdinanceOfType: (type) => {
      return effectiveOrdinances.some((effectiveOrdinance) => effectiveOrdinance.type === type)
    },
    ownedByOtherUser: (type) => {
      const ordinanceTypes = ['BAPTISM', 'CONFIRMATION', 'INITIATORY', 'ENDOWMENT', 'SEALING_TO_PARENTS']
      const slicedOrdinanceTypes = ordinanceTypes.slice(0, ordinanceTypes.indexOf(type) + 1)
      const reservationOwners = slicedOrdinanceTypes.map(
        (slicedType) => ordinanceData.ordinances?.find((ordinance) => ordinance.type === slicedType)?.reservationOwner
      )
      if (reservationOwners?.some((reservationOwner) => reservationOwner && reservationOwner !== 'MMMM-MM6')) {
        return true
      }
      return false
    },
    isGoodToPrint: () => {
      return (
        printCardsState.checkboxBaptism ||
        printCardsState.checkboxConfirmation ||
        printCardsState.checkboxInitiatory ||
        printCardsState.checkboxEndowment ||
        (printCardsState.checkboxSealingToParents && printCardsState.selectedParents) ||
        (printCardsState.checkboxSealingToSpouse && printCardsState.selectedSpouse)
      )
    },
    addOrdinanceIfChecked: (requestBody, checked, ordinanceType, personIds) => {
      if (checked) {
        requestBody.ordinances.push({
          type: ordinanceType,
          ...personIds,
        })
      }
    },
    print: async () => {
      const requestBody = {
        personId: currentPerson.id,
        ordinances: [],
      }

      printCardsActions.addOrdinanceIfChecked(requestBody, printCardsState.checkboxBaptism, 'BAPTISM')
      printCardsActions.addOrdinanceIfChecked(requestBody, printCardsState.checkboxConfirmation, 'CONFIRMATION')
      printCardsActions.addOrdinanceIfChecked(requestBody, printCardsState.checkboxInitiatory, 'INITIATORY')
      printCardsActions.addOrdinanceIfChecked(requestBody, printCardsState.checkboxEndowment, 'ENDOWMENT')
      printCardsActions.addOrdinanceIfChecked(
        requestBody,
        printCardsState.checkboxSealingToParents,
        'SEALING_TO_PARENTS',
        {
          fatherId: printCardsState.selectedParents?.relationship?.parent1?.personId,
          motherId: printCardsState.selectedParents?.relationship?.parent2?.personId,
        }
      )
      printCardsActions.addOrdinanceIfChecked(
        requestBody,
        printCardsState.checkboxSealingToSpouse,
        'SEALING_TO_SPOUSE',
        {
          spouseId: printCardsState.selectedSpouse?.relationship?.spouse?.personId,
        }
      )

      return createCards(requestBody, printCardsState.checkboxExcludeContactInfo, printCardsState.selectedLang)
        .then((createResponse) => {
          const pdfId = createResponse.data
          return getCards(pdfId)
            .then((response) => {
              const blob = new Blob([response.data], {
                type: 'application/pdf',
              })
              saveAs(blob, `${currentPerson.id}_family-cards.pdf`)
              printCardsActions.handleClose()
              return Promise.resolve()
            })
            .catch((err) => {
              error(
                t('person.ordinances.errors.gettingFamilyCards', {
                  defaultValue: `Error getting family cards: ${err.message || ''}`,
                  message: err.message || '',
                }),
                err
              )
              return Promise.resolve() // error has been handled
            })
        })
        .catch((err) => {
          const backendMessage = err.response?.data?.notifications
            .map((notification) => {
              if (notification.msg.includes('Person ID can not be null or empty')) {
                notification.msg =
                  'Person ID can not be null or empty (Make sure input fields for Sealing to Parents/Spouse are not blank)'
              }
              return notification.msg
            })
            .join('\n')
          error(
            t('person.ordinances.errors.creatingFamilyCards', {
              defaultValue: `Error creating family cards: ${backendMessage}`,
              message: backendMessage,
            }),
            err
          )
          return Promise.resolve(backendMessage) // error has been handled
        })
    },
  }

  return { printCardsState, printCardsActions }
}
